
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/[campaignSlug]",
      function () {
        return require("private-next-pages/campaigns/[campaignSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/[campaignSlug]"])
      });
    }
  